import { RETRIEVE_CATEGORIES } from "../actions/categories";
import { Categories } from "./state";
import { AnyAction } from "redux";
import { Reducer } from "react";

const initialState: Categories = {
    data: [],
};

const categoriesReducer: Reducer<Categories, AnyAction> = (
    state = initialState,
    action: AnyAction
) => {
    const { type, payload } = action;

    switch (type) {
        case RETRIEVE_CATEGORIES:
            return {
                ...state,
                data: payload.data,
            };
        default:
            return state;
    }
};

export default categoriesReducer;
